import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-input-date-custom',
  templateUrl: './input-date-custom.component.html',
  styleUrls: ['./input-date-custom.component.less']
})
export class InputDateCustomComponent implements OnInit, OnDestroy {

  inputValue: string;
  showError = false;
  @Input() eventValidate: Observable<number[]>;
  @Input() eventValidateSubscription: any;
  @Input() id: number;

  minYear = 1900;
  maxDate = new Date(9999, 11, 31);
  minDate = new Date(1900, 0, 1);

  @Output()
  inputChange = new EventEmitter<string>();

  @Input()
  get input() {
    return this.inputValue;
  }

  set input(val) {
    this.inputValue = val;
    this.inputChange.emit(this.inputValue);
  }

  constructor() {
  }

  ngOnInit() {
    if (this.eventValidate) {
      this.eventValidateSubscription = this.eventValidate.subscribe((listId) => {
        if (listId.includes(this.id)) {
          this.showError = !this.inputValue;
          this.checkValidMinDate();
        } else {
          this.showError = false;
        }
      });
    }
  }

  checkValidMinDate() {
    if (this.inputValue) {
      const yearInput = new Date(this.inputValue).getFullYear();
      if (yearInput < this.minYear) {
        this.showError = true;
      }
    }
  }

  onInputChange(event: any) {
    if (this.eventValidate) {
      this.showError = !event;
      this.checkValidMinDate();
    }
  }

  ngOnDestroy(): void {
    if (this.eventValidateSubscription) {
      this.eventValidateSubscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/input-date-custom/input-date-custom.component.ts